<template>
    <div style="height:100%">
        <div class="search-wrapper">
            <div>
                <span>归属团队：</span>
                <Input disabled style="width:150px;margin-right:20px" value="军工事业部"></Input>
                <span>所属行业：</span>
                <Input v-model="searchSysIndustry" style="width:150px;margin-right:20px;"></Input>
                <span>单位名称:</span>
                <Input style="width:150px;margin:5px 10px;" type="text" v-model="searchName"/>
                <span>单位属性：</span>
                <Input v-model="searchPurchaseSite" style="width:150px;margin-right:20px;"></Input>
                <br />
				<span>手机号码：</span>
				<Input v-model="searchContactMethod" style="width:150px;margin-right:20px;"></Input>
				<span>联系人：</span>
				<Input v-model="searchContact" style="width:150px;margin-right:20px;"></Input>
				<span>客户人员：</span>
				<Input v-model="searchAssistant" style="width:150px;margin-right:20px" :readonly="!permission"></Input>
				<Button type="primary" @click="search" style="margin-right:10px">搜索</Button>
                <Button type="primary" @click="show('',true,'新增','0')" style="margin-right:10px">新增采购人</Button>
                <Button type="primary" @click="setting" icon="navicon-round" v-show="isHeader">管理</Button>
			</div>
            <div style="margin-top:10px;display:flex;justify-content:space-between;align-items:flex-end">
                <ButtonGroup style="background:#fff">
                    <Button v-for="(item,i) in customNumArr" :key="i" type="ghost" :style="{color:currentIndex==i?'#2d8cf0':'#000'}" @click="tabChange(i)">
                        {{item}}
                    </Button>
                </ButtonGroup>
                <Checkbox v-model="showOnly" style="float:right" v-show="isHeader">只显示未指派客户的采购人</Checkbox>
            </div>
        </div>
        <div v-if="currentIndex===0">
            <Table :columns="columns" :data="purchaserData" style="min-width:1000px;"></Table>
            <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" show-elevator show-total style="margin-top:5px;" @on-change="pageChange"></Page>
        </div>
        <iframe :src="reportUrl" style="width:100%;height:460px;border:0" v-else></iframe>
        <Modal v-model="addPVisible" :title="title" width="900" :mask-closable="false">
            <purchaser-card  v-on:ok="addOK" :curPurchaserData="curPurchaserData" :editSta="editSta" :id="id" :time="time"></purchaser-card>
            <div slot="footer"></div>
        </Modal>
        <!-- 管理 弹窗 -->
        <Modal v-model="showSetting" title="客户管理" class-name="settingModal">
            <Table :columns="amColumns" :data="amArr"></Table>
            <div slot="footer"></div>
        </Modal>
        <!-- 委派客户 弹窗 -->
        <Modal v-model="showAssistant" title="委派客户" class-name="settingModal">
            <Table :columns="amColumns" :data="amArr"></Table>
            <div slot="footer"></div>
        </Modal>
        <!-- 附表信息 -->
        <Modal v-model="showSecretForm" title="附表信息">
            <secret-info ref="secretInfo" :purchaseData="curPurchaserData" @close="showSecretForm=false" :show="showSecretForm"></secret-info>
            <div slot="footer">
                <Button @click="showSecretForm=false">取消</Button>
                <Button @click="$refs.secretInfo.submit()" type="primary">提交修改</Button>
            </div>
        </Modal>
    </div>
  </template>
<script>
    import requestUrls from '@/lib/eRequestUrls'
    import purchaserCard from "@/components/purchaserCard"
    import ajax from '@/lib/ajax'
    import userAjax from '@/lib/userAjax'
    import secretInfo from './secretInfo'

    export default {
        components: {
            purchaserCard,
            secretInfo
        },
        name: 'purchaserTable',
        data() {
            return {
                columns: [],
                baseColumns: [{
                    title: '归属团队',
                    key: 'filiale',
                    align: 'center',
                    width: 100,
                }, {
                    title: '单位名称',
                    key: 'purchase',
                }, {
                    title: '客户人员',
                    key: 'accountAssistant',
                    align: 'center',
                    width: 90,
                },{
                    title: '所属行业',
                    key: 'sysIndustry',
                    width: 120,
                },{
                    title: '联系人',
                    key: '联系人',
                    width: 135,
                },{
                    title: '联系方式',
                    key: '联系方式',
                    width: 135,
                },{
                    title: '座机号码',
                    key: '座机号码',
                    width: 135,
                }],
                operationColumns: [{
                    title: '操作',
                    key: 'action',
                    width: 230,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.row,false,'查看','1')
                                    }
                                }
                            }, '查看详情'),
                            h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px',
                                    display: this.isHeader ? 'inline-block' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.curPurchaserData = params.row
                                        this.$Spin.show()
                                        // 获取客户人员
                                        userAjax.get(requestUrls.ClPurchase.GetAmClientQuota, {
                                            params: {
                                                district: params.row.filiale
                                            }
                                        }).then(res => {
                                            // 获取客户数量
                                            ajax.post(requestUrls.ClPurchase.PostAMCount, {
                                                data: res.data.result.items
                                            }).then(am => {
                                                this.$Spin.hide()
                                                this.amArr = am.data.result.items
                                                this.showAssistant = true
                                            })
                                        })
                                    }
                                }
                            }, '委派客户'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.row,true,'修改','2')
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.curPurchaserData = params.row
                                        this.showSecretForm = true
                                    }
                                }
                            }, '附表')
                        ]);
                    }
                }],
                pageNum: 1,
                pageTotal: 0,
                pageSize: 10,
                purchaserData: [],
                searchName:'',//查询框的值
                addPVisible:false, //添加采购人信息的modal的open情况
                curPurchaserData:{},//通道信息 -- 查看采购人信息
                editSta:false, // 为 false 表示 查看信息状态；为 true 表示 新增或者修改状态
                title:"", //取值 有 “新增” “查看” “修改”
                id:'',//0表示 新增 1 表示 查看 2 表示修改
                time:'',//时间戳 
                searchSysIndustry: '',
                searchPurchaseSite: '',
                searchContact: '',
                searchContactMethod: '',
                searchAssistant: '',
                customNumArr: ['全部', '已成交客户', '未成交客户'],
                currentIndex: 0,
                showSetting: false,
                amArr: [],
                quota: '',
                amColumns: [
                    {
                        title: '姓名',
                        key: 'am',
                    },
                    {
                        title: '客户数量',
                        key: 'count',
                        align: 'center',
                    },
                    {
                        title: '限额',
                        key: 'clientQuota',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.clientQuota === null) return  h('div', '无')
                            return  h('div', params.row.clientQuota)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                    },
                                    style: {
                                        color: '#2d8cf0',
                                        display: this.showSetting ? 'block' : 'none' 
                                    },
                                    on: {
                                        click: () => {
                                            this.quota = params.row.clientQuota
                                            this.$Modal.confirm({
                                                title: '限额设置',
                                                render: (h) => {
                                                    return h('div', [
                                                        h('p', {
                                                            style: {
                                                                margin: '20px 0 5px',
                                                            },
                                                            on: {}
                                                        }, '请输入限额数量(整数)：'),
                                                        h('Input', {
                                                            props: {
                                                                value: this.quota,
                                                                autofocus: true,
                                                                placeholder: '不可低于当前客户数量，输入空值表示无上限'
                                                            },
                                                            on: {
                                                                input: (val) => {
                                                                    this.quota = val
                                                                }
                                                            }
                                                        })
                                                    ])
                                                },
                                                onOk: () => {
                                                    // 检验是否低于当前客户数量
                                                    if (parseInt(this.quota) < params.row.count) {
                                                        this.$Message.error('限额不可低于当前客户数量！')
                                                        return
                                                    }
                                                    // 设置客户限额
                                                    this.$Spin.show()
                                                    let quota = isNaN(parseInt(this.quota)) ? null : parseInt(this.quota)
                                                    userAjax.put(`/api/services/app/User/UpdateClientQuota`,{
                                                        "userId": params.row.userId,
                                                        "clientQuota": quota
                                                    }, {
                                                        headers: {
                                                            'content-type': 'application/json'
                                                        }
                                                    }).then(res => {
                                                        this.$Message.success('设置成功')
                                                        this.$Spin.hide()
                                                        this.getAm()
                                                    })
                                                }
                                            })
                                        }
                                    }
                                }, '设置上限'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        disabled: !(params.row.clientQuota==null||params.row.clientQuota>params.row.count)
                                    },
                                    style: {
                                        color: '#2d8cf0',
                                        display: this.showAssistant ? 'block' : 'none' 
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: '委派确认',
                                                content: `确定将采购人（${this.curPurchaserData.purchase}）指派给客户人员${params.row.am}吗？`,
                                                onOk: () => {
                                                    // 修改采购人信息
                                                    let clPurchase = Object.assign({}, this.curPurchaserData)
                                                    clPurchase.accountAssistant = params.row.am
                                                    clPurchase.contactPersonOrWay = JSON.stringify(clPurchase.contactPersonOrWay)
                                                    ajax.post(requestUrls.ClPurchase.CreateOrUpdate, {
                                                        clPurchase: clPurchase
                                                    }).then(res => {
                                                        this.$emit('ok', false) //关闭父组件所在 Modal
                                                        this.$Message.success('操作成功')
                                                        this.showAssistant = false
                                                        this.getPurchaser('%', 1)
                                                    })
                                                }
                                            })
                                        }
                                    }
                                }, '选择委派')
                            ]);
                        }
                    },
                ],
                reportSearch: '',
                showOnly: false,
                showAssistant: false,
                showSecretForm: false
            }
        },
        // 得到第一页采购人数据
        async created() {
            this.columns = [...this.baseColumns, ...this.operationColumns]
            this.getPurchaser("%",1);
        },
        computed: {
            permission () {
                let permission = this.$store.getters["session/hasRoles"]("分公司负责人") || this.$store.getters["session/hasRoles"]("档案管理员")
                if (!permission) this.searchAssistant = this.$store.state.session.user.name
                return permission
            },
            isHeader () {
                return this.$store.getters["session/hasRoles"]("分公司负责人")
            },
            reportUrl () {
                let params = ''
                if (this.$store.getters["session/hasRoles"]("分公司负责人")) {
                    params = `&UserName=${this.$store.state.session.user.name}` + this.reportSearch
                    switch (this.currentIndex) {
                        case 1:    // 已成交客户
                            return `http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/采购人/军工采购人档案(新客户).cpt${params}`
                            break
                        case 2:   // 未成交客户
                            return `http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/采购人/军工采购人档案(旧客户).cpt${params}`
                            break
                    }
                } else {
                    params = `&khjl=${this.$store.state.session.user.name}` + this.reportSearch
                    switch (this.currentIndex) {
                        case 1:    // 已成交客户
                            return `http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/采购人/军工采购人档案(新客户).cpt${params}`
                            break
                        case 2:   // 未成交客户
                            return `http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/采购人/军工采购人档案(旧客户).cpt${params}`
                            break
                    }
                }
            }
        },
        watch: {
            showOnly (val) {
                this.search()
            }
        },
        methods: {
            // 得到采购人数据
            async getPurchaser(value,page) {
                var page=page;
                this.pageNum = page
                // 地区 分公司 权限
                let filiale = 'filiale like "军工事业部"'
                let sysIndustry = this.searchSysIndustry ? ` and sysIndustry like "${this.searchSysIndustry}"` : ""
                let purchaseSite = this.searchPurchaseSite ? ` and purchaseSite like"${this.searchPurchaseSite}"` : ""
                let contact = this.searchContact ? ` and contactPersonOrWay like "${this.searchContact}"` : ""
                let contactMethod = this.searchContactMethod ? ` and contactPersonOrWay like "${this.searchContactMethod}"` : ""
                let purchase = this.searchName ? ` and purchase like "${this.searchName}"` : ""
                let searchAssistant = this.searchAssistant ? ` and accountAssistant like "${this.searchAssistant}"` : ""
                if (this.showOnly) searchAssistant = ` and accountAssistant==null`
                // 客户人员权限 非公司负责人/档案管理员 只允许查看自己负责的采购人
                if (!this.permission) searchAssistant = ` and accountAssistant like "${this.$store.state.session.user.name}"`
                let querySear = filiale + sysIndustry + purchaseSite + contact + contactMethod + purchase + searchAssistant
                ajax.get('https://www.choicelink.cn:8444/cailian/api/dotnettoken/clPurchase/getPaged',{
                    params: {
                        filter: querySear,
                        pageNum: page,
                        pageSize: 10,
                        // sorting: 'visitDate desc'
                    }
                }).then(req => {
                    if (req.data.success) {
                        // 数据加载成功 销毁 loading
                        //this.$Message.destroy()
                        var value = req.data.result.items;
                        var list = value.map(current => {
                            var cus_tel = current.contactPersonOrWay;
                            if (cus_tel){
                                cus_tel = cus_tel.replace(/\s+/g, ""); //去掉空格
                                cus_tel = cus_tel.replace(/'/g, '"');  //去除单引号
                                var regex = /\{(.+?)\}/g;  // 匹配{} 
                                var midValue = cus_tel.match(regex);
                                if (midValue!=null) { //避免值为空
                                    var endValue = midValue.map(JSON.parse);
                                    // var value = endValue.map(function(currentValue) {
                                    //      return {"联系人":currentValue.联系人 || "空",
                                    //      "联系方式":currentValue.联系方式 || "空",
                                    //      "座机号码":currentValue.座机号码 || "空"}
                                    //      });
                                    current.联系人=endValue[0].联系人|| "空";
                                    current.联系方式=endValue[0].联系方式|| "空";
                                    current.座机号码=endValue[0].座机号码|| "空";
                                    current.contactPersonOrWay=endValue;
                                    return current;
                                } else {
                                    current.联系人="空";
                                    current.联系方式="空";
                                    current.座机号码="空";
                                    current.contactPersonOrWay=[];
                                    return current;
                                }                
                            } else {
                                current.联系人="空";
                                current.联系方式="空";
                                current.座机号码="空";
                                current.contactPersonOrWay=[];
                                return current;
                            }
                        });
    
                        this.purchaserData =list;
                        this.pageTotal = (req.data.result.totalCount);
                    }
                })
            },
            pageChange(pageNum) {
                this.getPurchaser("%"+this.searchName+"%",pageNum);
            },
            tabChange (i) {
                this.currentIndex = i
                this.search()
            },
            // 搜索
            search () {
                if (this.currentIndex === 0) {
                    this.getPurchaser('%',1)
                } else {   // 报表查询
                    let sysIndustry = this.searchSysIndustry ? `&hyxt=${this.searchSysIndustry}` : ""
                    let purchase = this.searchName ? `&purchaseName=${this.searchName}` : ""
                    let purchaseSite = this.searchPurchaseSite ? `&purchaseSite=${this.searchPurchaseSite}` : ""
                    let contactMethod = this.searchContactMethod ? `&contactWay=${this.searchContactMethod}` : ""
                    let contact = this.searchContact ? `&contactPerson=${this.searchContact}` : ""
                    let assistant = this.searchAssistant ? `&khjl=${this.searchAssistant}` : ""
                    let state = this.showOnly ? `&state=1` : "&state=0"
                    this.reportSearch = filiale + sysIndustry + purchase + purchaseSite + contactMethod + contact + assistant + state
                }
            },
            // 新增采购人成功 关闭 Modal
            addOK:function(value) {
                this.addPVisible=value;
                this.getPurchaser("%"+this.searchName+"%",this.pageNum); //刷新页面
                // this.purchaserData=this.purchaserData;
            },
            // 新增 -- 查看 -- 编辑 采购人信息
            show:function(value,tf,title,id) {
                this.curPurchaserData=value;
                this.addPVisible=true;
                this.editSta=tf;
                this.title=title+'采购人信息';
                this.id=id;
                this.time = new Date().getTime();
            },
            setting () {
                this.showSetting = true
                this.getAm()
            },
            getAm () {
                // 获取客户人员
                this.$Spin.show()
                userAjax.get(requestUrls.ClPurchase.GetAmClientQuota).then(res => {
                    // 获取客户数量
                    ajax.post(requestUrls.ClPurchase.PostAMCount, {
                        data: res.data.result.items
                    }).then(am => {
                        this.$Spin.hide()
                        this.amArr = am.data.result.items
                    })
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    .search-wrapper {
        width: 100%;
        margin: 0 0 10px;
        display:inline-block;
    }
</style>
<style lang="less">
.settingModal {
    .ivu-modal-body {
        max-height: 400px;
        overflow-y: scroll;
    }
}
</style>